// import AuthService from "../services/auth.service";
import { React } from 'react'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Navigate, useNavigate } from 'react-router-dom'
import { openMessage } from './messageSlice'
import { API_ACCOUNT } from '../../constants'
import Cookies from 'js-cookie'

const user = JSON.parse(localStorage.getItem('user'))

const initialState = user
  ? {
      startApp: false,
      isLoggedIn: true,
      user: user,
    }
  : {
      startApp: true,
      isLoggedIn: false,
      user: '',
      // user: [],
    }

export const login = createAsyncThunk(
  'auth/login',
  async ({ username, password }, thunkAPI) => {
    const response = await fetch(`${API_ACCOUNT}/auth/login`, {
      method: 'POST',
      headers: {
        // 'Access-Control-Allow-Credentials': 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'Access-Control-Allow-Origin': '*',
      },
      // body: new URLSearchParams({
      //   username: username,
      //   password: password,
      //   grant_type: 'password',
      //   captcha: captcha,
      // }),
      body: `username=${username}&password=${password}&grant_type=password`,
    })
    console.log(response.status)
    if (response.status === 200) {
      // console.log(response.status)
      const responseJson = await response.json()
      // thunkAPI.dispatch(getCardStat());
      // console.log(responseJson)
      if (responseJson.roles[0] === 'ENGINEER') {
        thunkAPI.dispatch(
          openMessage({
            message: 'Maaf, Engineer Tidak Bisa Mengakses M-Bravo versi Web',
            type: 'failed',
            open: true,
          }),
        )
        return null
      } else {
        thunkAPI.dispatch(
          openMessage({
            message: 'Sukses Login!',
            type: 'success',
            open: true,
          }),
        )
        thunkAPI.dispatch(
          loginState({
            pass: password,
          }),
        )

        return responseJson
      } 
    } else if (response.status === 400) {
      // const responseJson = await response.json()
      // if (responseJson.error_description === 'invalid captcha')
      //   thunkAPI.dispatch(
      //     openMessage({
      //       message: 'Invalid Captcha',
      //       type: 'failed',
      //       open: true,
      //     }),
      //   )
      // return null
      thunkAPI.dispatch(
        openMessage({
          message: 'Invalid Username Or Password',
          type: 'failed',
          open: true,
        }),
      )
      return null
    }
  },
)

// export const logout = createAsyncThunk("auth/logout", async () => {
//   await AuthService.logout();
// });

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = []
      state.isLoggedIn = false
      state.startApp = true
      // const navigate = useNavigate()
      localStorage.clear()
      Cookies.remove('accessToken'); 
      if (localStorage.getItem('user') === null) {
        // navigate('#/login')
        // console.log('test bung')
        window.location.href = '/login'
      }
    },
    loginState: (state, action) => {
      state.pass = action.payload.pass
    },
  },
  extraReducers: {
    // [register.fulfilled]: (state, action) => {
    //   state.isLoggedIn = false;
    // },
    // [register.rejected]: (state, action) => {
    //   state.isLoggedIn = false;
    // },
    [login.fulfilled]: (state, action) => {
      if (action.payload === null) {
        state.isLoggedIn = false
        state.startApp = false
      } else {
        state.isLoggedIn = true
        state.startApp = false
        state.user = action.payload
        Cookies.set('accessToken', action.payload.access_token, { expires: 1 });
        localStorage.setItem('user', JSON.stringify(action.payload))
      }
      // let wrapping = [action.payload].flat();

      // console.log(action.payload);
    },
    [login.rejected]: (state, action) => {
      state.isLoggedIn = false
      state.user = null
    },
    // [logout.fulfilled]: (state, action) => {
    //   state.isLoggedIn = false
    //   state.user = null
    // },
  },
})

export const { logout, loginState } = authSlice.actions
export default authSlice.reducer
